import { render, staticRenderFns } from "./ci_analytics_list.vue?vue&type=template&id=2d2e4d84"
import script from "./ci_analytics_list.vue?vue&type=script&lang=js"
export * from "./ci_analytics_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports